import { Flex } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { AiAdr } from "@/icons"
import { InformationPopover } from "@/molecules/InformationPopover"
import { CardSectionTemplate } from "@/pages/TriagePage/components/pages/AdrManagementPage/components/templates/CardSectionTemplate"
import { PopoverCard } from "../PopoverCard"
import { PopoverRuleCard } from "./PopoverRuleCard"

import styles from "./RuleCard.module.scss"

import type { RuleDTO } from "@/domain/adr"
import type { RuleCardProps } from "."

export const RuleCard = (props: RuleCardProps) => {
  const { name, data, type, disabled } = props
  const { rules, detectedIncidentsCount } = data
  const { ids = [], alphaIds = [] } = rules || {}
  const { t } = useTranslation("translation", {
    keyPrefix: "triage.adr.management"
  })

  return (
    <InformationPopover.Popover
      classNamePopover={styles.popover}
      placement="top"
      content={
        <Flex vertical>
          <PopoverCard<RuleDTO>
            name={name}
            description={`${t("detectionType")}:`}
            title={`${t("detections")}:`}
            list={ids}
            subList={alphaIds}
            componentProps={{ disabled }}
            Component={PopoverRuleCard}
          />
        </Flex>
      }
    >
      <span>
        <CardSectionTemplate
          variant="sm"
          hasIncidents={!!detectedIncidentsCount}
        >
          <Flex gap={6} align="center">
            <span className={styles.text}>{name}</span>
            {type === "AI" && <AiAdr className={styles.iconAi} />}
          </Flex>
        </CardSectionTemplate>
      </span>
    </InformationPopover.Popover>
  )
}
